import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Typography } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import { makeStyles, Theme } from '@material-ui/core/styles'
import React, { FC } from 'react'
import { advancedFilterDefaultColor } from 'shared/common/productListingDialogColors'

const useStyles = makeStyles((theme: Theme) => ({
    clearAllContainer: {
        flex: 1,
        display: 'flex',
        minWidth: pxToRem(90),
        justifyContent: 'flex-end',
    },
    clearAllButton: {
        color: advancedFilterDefaultColor,
        fontWeight: 500,
        padding: theme.spacing(0, 3),
        textAlign: 'left',
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: 'transparent',
        },
        '&>.MuiButton-label': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    },
}))

const ClearButton: FC<{ handleClearAllClick: () => void }> = ({
    handleClearAllClick,
}) => {
    const classes = useStyles()

    return (
        <Typography component="span" className={classes.clearAllContainer}>
            <Button
                data-testid="productDialogAdvancedFilterClearAllButton"
                disableRipple={true}
                onClick={handleClearAllClick}
                className={classes.clearAllButton}
            >
                Clear All
            </Button>
        </Typography>
    )
}

export default ClearButton
